import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import './BKSelect.css';

const BKSelect = ({
  label,
  options = [],
  value,
  onChange,
  placeholder = 'Chọn...',
  disabled = false,
  multiple = false,
  showSearch = true,
  getOptionLabel = (option) => option.label || option.name || option,
  getOptionValue = (option) => option.value || option.id || option,
  allowClear = true,
  name,
  style = {},
  error = false,
  size,
  ...rest
}) => {
  const handleChange = (val) => {
    if (onChange) {
      onChange({
        target: {
          name,
          value: val
        }
      });
    }
  };

  const displayValue =
    value === '' || value === 0 || value === '0' ? undefined : value;

  return (
    <div
      className={`bk-select-container${error ? ' bk-select-error' : ''}${size === 'small' ? ' bk-select-sm' : ''}`}
      style={style}>
      {label && <label className="bk-select-label">{label}</label>}
      <Select
        mode={multiple ? 'multiple' : undefined}
        value={displayValue}
        onChange={handleChange}
        placeholder={placeholder}
        disabled={disabled}
        showSearch={showSearch}
        allowClear={allowClear}
        filterOption={(input, option) => {
          const label = (option?.children || '').toLowerCase();
          return label.includes(input.toLowerCase());
        }}
        getPopupContainer={() => document.body}
        placement="bottomLeft"
        dropdownStyle={{ zIndex: 2000 }}
        {...rest}>
        {options
          .filter((option) => getOptionValue(option) !== 0)
          .map((option) => (
            <Select.Option
              key={getOptionValue(option)}
              value={getOptionValue(option)}>
              {getOptionLabel(option)}
            </Select.Option>
          ))}
      </Select>
    </div>
  );
};

BKSelect.propTypes = {
  label: PropTypes.string,
  options: PropTypes.array,
  value: PropTypes.any,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  multiple: PropTypes.bool,
  showSearch: PropTypes.bool,
  getOptionLabel: PropTypes.func,
  getOptionValue: PropTypes.func,
  allowClear: PropTypes.bool,
  name: PropTypes.string,
  style: PropTypes.object
};

export default BKSelect;
